var _defs, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgBarDroit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 470 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_555",
    x1: 10.5,
    y1: 10.5,
    x2: 455.5,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5d23d3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#7718c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b300a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffca00"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_3",
    "data-name": "Calque 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bar"
  }, /*#__PURE__*/React.createElement("image", {
    width: 470,
    height: 25,
    opacity: 0.64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAdYAAAAZCAYAAACM0w+PAAAACXBIWXMAAAsSAAALEgHS3X78AAADAElEQVR4Xu3d3U4bMRCG4Xch/KSFotL7v0igkIYQtgf2ZB3Hm1SoJ5j3kawsq0QcfpoZe3cYxxFJkvR/LE59oWUYhuHUdyRJ+uzGD1Sfw6nfVCE6dy1JUm/KgNxdnwrb2WDNgRrheRa3iyVJUu/GYgG8x/25gG22gotQPWusuA8GrCSpT2WQjvlzbw3D0KxeDyrWHKoRoud5LYp1zhSwtoYlSb2oW78RqFvgrVjbvN6B9zpc9yrWqlJdABfAZV5X+fOCKXANVklSL+pgjQDdAK/AOn++5ntvwFhXrnUrOEL1nBSgV8C3Yi3zvYv8W2eukqSelDPVN1KAroEV8JJXZF5Z1R4Ga7H7twzWJXAL/MjrhhSwEa6tlrAkSZ9VGZYRqi/Ab+CRlI9lizjmrUNUrXMV64KpWr0FfgL3wF3+e0lqC0c72GCVJPUggnVLavmugCfggSlU63nrQKtizSIko2K9Br6TAvUe+JWvo2ot28GSJH12ZRs4qtUlKRe3TG3hFTPFZeu4TT1nvSYF6Q2pHXyXr6/z7z16I0nqQXnE5g34Q8rBkRSoz6Tsi028MQ7dUwbrUK3yyE3sEC53CV8yBauhKknqQcxPz/JnnIaJTbsRqOUeo1gHM9axWnEINs7vbJi2HL8y/VMrVklSD+qKtTxaE8drdhuWOMxNoN0KLnc7bUilcOyIuiIF6AZnrJKk/rRmrI+kDHwhZeKGKWB3gRrqYC13Q0WoPjPthtqSBrbuCpYk9ejYruAHUiaW4bpXrUI7WKMEjqSOqjRC9RHPsUqS+lSOQ1vnWJ/y32tSVh5UrbtgHcdxzA+JKNvAK6ZQXTO1g33ykiSpR+XMdO7JSyv228FHH2lYz1fjXrSFfVawJKlXZeUZ7eBjzwpuzll9u40kSUkdrGWx+c9vt2m+6Nz3sUqSvrgIx9n3sUL7ZefNYIW9cIX9IHWmKkn6KsqZK+SZKjOhCkeCdfeF6a03YOtXkvR11K3hdHEiOE8Ga0sVtpIkdelUiLZ8KFglSVLbXw0TWX2IXVeEAAAAAElFTkSuQmCC",
    style: {
      mixBlendMode: "multiply"
    }
  }), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 10.5,
    x2: 455.5,
    y2: 10.5,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7,
    stroke: "url(#D\\xE9grad\\xE9_sans_nom_555)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBarDroit);
export default __webpack_public_path__ + "static/media/imgBarDroit.58034159b3f6403a989d1ec783c1107a.svg";
export { ForwardRef as ReactComponent };